export default '/build/b168601c.svg'